import { createActionCreator } from "common/ReduxUtils";
import { CaseDimensionCollection } from "./CaseDimensionCollection.types";
import { StorageCaseDimensionsActionTypes } from "./StorageCaseDimensionsAction.types";

export const setSelectedProductsCaseDimensions = createActionCreator<CaseDimensionCollection>(
  StorageCaseDimensionsActionTypes.STORAGE_SET_CASE_DIMENSIONS,
  "selectedProductsCaseDimensions"
);
